import { render, staticRenderFns } from "./tqhy.vue?vue&type=template&id=5f71c7f8"
import script from "./tqhy.vue?vue&type=script&lang=js"
export * from "./tqhy.vue?vue&type=script&lang=js"
import style0 from "./tqhy.vue?vue&type=style&index=0&id=5f71c7f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports